import React from 'react';
import PropTypes from 'prop-types';
import formatMessage from 'format-message';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';

import env from '../../../config/env';

export default class ResourcePreviewDocument extends React.Component {
  static propTypes = {
    learningObject: PropTypes.object.isRequired
  }

  render () {
    const { learningObject } = this.props;
    const { canvadocsDocumentId } = (learningObject.versions || [])[0] || {};
    const { documentPreview } = (learningObject.meta || {}).links || {};
    if (!canvadocsDocumentId || !documentPreview) return <div />;

    return (
      <section>
        <ScreenReaderContent as="h2">
          {formatMessage('Document Preview')}
        </ScreenReaderContent>
        <iframe
          className="lor-document-preview"
          src={`${documentPreview}?session-id=${env.SESSION_ID}`}
          allowFullScreen
        />
      </section>
    );
  }
}
